/* eslint-disable jira/filename-case */
import shallowEqual from './shallowEqual.tsx';

function exactEqual(objA: object, objB: object) {
	return objA === objB;
}

// oxlint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
function areArgumentsEqual(propsMode: boolean, prev: IArguments, next: any) {
	if (prev === null || next === null || prev.length !== next.length) return false;

	// If propsMode and 2 arguments, means it is an input selector
	// and we check for shallow equality on 2nd one to optimise props
	if (propsMode && prev.length === 2) {
		return prev[0] === next[0] && shallowEqual(prev[1], next[1]);
	}

	for (let i = 0; i < prev.length; i++) {
		if (!exactEqual(prev[i], next[i])) return false;
	}

	return true;
}

/**
 * Tailor made memoisation
 */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
const memoize = function memoize(resultFn: any, propsMode = false): any {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
	let lastArgs: any = [];
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
	let lastResult: any;
	let calledOnce = false;

	// oxlint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
	const result = function result(this: any) {
		// oxlint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
		if (calledOnce && areArgumentsEqual(propsMode, arguments, lastArgs)) {
			return lastResult;
		}

		// oxlint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
		const nextResult = resultFn.apply(this, arguments);
		if (!propsMode && shallowEqual(nextResult, lastResult)) {
			return lastResult;
		}

		lastResult = nextResult;
		calledOnce = true;
		// oxlint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
		lastArgs = arguments;
		return lastResult;
	};

	return result;
};

export default memoize;
